import React from 'react';
import { colors } from 'design-system';
import VectorIcon from './VectorIcon';

const CarIcon = (): JSX.Element => (
  <VectorIcon width={41} height={20}>
    <svg
      width="41"
      height="20"
      viewBox="0 0 41 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.7086 6.66661H19.231V4.16661C19.231 3.70661 18.8587 3.33325 18.4001 
        3.33325C17.9415 3.33325 17.5692 3.70661 17.5692 4.16661V7.49997C17.5692 7.95997 
        17.9415 8.33333 18.4001 8.33333H26.7086C27.1672 8.33333 27.5395 7.95997 27.5395
        7.49997C27.5395 7.03997 27.1672 6.66661 26.7086 6.66661Z"
        fill={colors.madison}
      />
      <path
        d="M32.5245 10C29.7761 10 27.5394 12.2434 27.5394 15C27.5394 17.7566 29.7761 
        20 32.5245 20C35.2729 20 37.5096 17.7566 37.5096 15C37.5096 12.2434 35.273 10 32.5245 
        10ZM32.5245 18.3334C30.6916 18.3334 29.2011 16.8384 29.2011 15C29.2011 13.1616 30.6916 
        11.6666 32.5245 11.6666C34.3573 11.6666 35.8479 13.1616 35.8479 15C35.8479 16.8384 
        34.3573 18.3334 32.5245 18.3334Z"
        fill={colors.madison}
      />
      <path
        d="M7.59909 10C4.85068 10 2.61401 12.2434 2.61401 15C2.61401 17.7566 4.85068 
        20 7.59909 20C10.3475 20 12.5842 17.7566 12.5842 15C12.5842 12.2434 10.3476 10 7.59909 
        10ZM7.59909 18.3334C5.76622 18.3334 4.27568 16.8384 4.27568 15C4.27568 13.1616 5.76622 
        11.6666 7.59909 11.6666C9.43196 11.6666 10.9225 13.1616 10.9225 15C10.9225 16.8384 
        9.43196 18.3334 7.59909 18.3334Z"
        fill={colors.madison}
      />
      <path
        d="M28.3702 15H11.7533C11.2946 15 10.9224 15.3734 10.9224 15.8334C10.9224 16.2934 
        11.2946 16.6667 11.7533 16.6667H28.3702C28.8288 16.6667 29.201 16.2934 29.201 
        15.8334C29.201 15.3734 28.8288 15 28.3702 15Z"
        fill={colors.madison}
      />
      <path
        d="M31.9959 5.00336C30.7796 4.03 25.2246 0 16.7383 0C15.1331 0 11.037 0.164999 
        7.34646 1.66664H3.44478C3.10914 1.66664 2.80505 1.87 2.67708 2.18164C2.54746 2.49328 
        2.61889 2.85 2.85654 3.09L3.66911 3.90336C1.86451 5.52664 0.95224 7.57336 0.95224 
        10C0.95224 12.8616 1.20983 16.6666 3.44478 16.6666C3.9034 16.6666 4.27565 16.2933 
        4.27565 15.8333C4.27565 15.3733 3.9034 15 3.44478 15C3.43816 14.9984 2.61391 14.5384 
        2.61391 10C2.61391 7.785 3.52617 6.03164 5.40056 4.635C5.59498 4.49 5.71626 4.26836 
        5.73456 4.02664C5.75287 3.785 5.66477 3.54828 5.49364 3.37664L5.45041 
        3.33328H7.51088C7.62056 3.33328 7.73023 3.31164 7.82993 3.26828C11.2846 1.82328 
        15.2112 1.66664 16.7383 1.66664C25.5353 1.66664 31.0936 6.415 31.1485 6.46164C31.2997 
        6.59328 31.4924 6.66664 31.6935 6.66664C37.0823 6.66664 39.1595 10.1266 39.1711 
        10.8333V14.1666C39.1711 14.6016 38.5314 14.9783 38.3402 15H36.6786C36.2199 15 35.8477 
        15.3734 35.8477 15.8334C35.8477 16.2934 36.2199 16.6667 36.6786 16.6667H38.3403C39.3439 
        16.6667 40.8328 15.6167 40.8328 14.1667V10.8334C40.8328 9.25336 38.1126 5.135 31.9959 
        5.00336Z"
        fill={colors.madison}
      />
    </svg>
  </VectorIcon>
);

export default CarIcon;
